import React, { useState } from "react";
import logo from "../assests/images/newLogo.png";
import "../styles/navbar.css";
import { NavLink } from "react-router-dom";
import CountrySelect from "./CountrySelect";
import Dropdown from "./NavDropdown";
import AboutDropdown from "./AboutDropdown";

export default function Navigation() {
  const [open, setOpen] = useState(false);

  // Close the menu when a link is clicked or on any interaction inside
  const closeMenu = () => setOpen(false);

  return (
    <header className="top-nav">
      {/* Logo on the left */}
      <div className="cloudare-logo">
        <a href="/" aria-label="Home">
          <img src={logo} height="75" alt="logo" />
        </a>
      </div>

      {/* Container for all right-side elements */}
      <div className="nav-right">
        {/* Main navigation with hamburger logic */}
        <nav className="main-nav">
          <input
            id="menu-toggle"
            type="checkbox"
            checked={open}
            onChange={() => setOpen((v) => !v)}
          />
          <label
            className="menu-button-container"
            htmlFor="menu-toggle"
            aria-expanded={open}
            aria-controls="navbar"
            aria-label="Toggle navigation menu"
          >
            <div className="menu-button"></div>
          </label>

          <ul
            className="menu"
            id="navbar"
            onClick={(e) => {
              // Close menu if a direct NavLink/link is clicked, but not for dropdowns
              if (
                e.target.tagName === "A" &&
                !e.target.closest(".item-has-dropdown")
              ) {
                closeMenu();
              }
            }}
          >
            {/* Added a class to specifically target this dropdown item */}
            <li className="item">
              <NavLink
                to="/"
                className={({ isActive }) => `link ${isActive ? "active" : ""}`}
              >
                Home
              </NavLink>
            </li>
            <li className="item item-has-dropdown">
              <Dropdown />
            </li>
            {/* <li className="item">
              <NavLink
                to="/hire-talent"
                className={({ isActive }) => `link ${isActive ? "active" : ""}`}
              >
                HR
              </NavLink>
            </li> */}

            <li className="item item-has-dropdown">
              <AboutDropdown />
            </li>

            {/* <li className="item">
              <NavLink
                to="/apply"
                className={({ isActive }) => `link ${isActive ? "active" : ""}`}
              >
                Apply for Jobs
              </NavLink>
            </li>

            <li className="item">
              <a
                href="https://blogs.cloudare.in/"
                className="link"
                target="_blank"
                rel="noreferrer"
              >
                Blogs
              </a>
            </li> */}
          </ul>
        </nav>

        {/* CountrySelect now outside the hamburger menu */}
        <div className="country-select-wrapper">
          <CountrySelect />
        </div>
      </div>
    </header>
  );
}
